<script setup lang="ts">
import SmoothenSlider from "@/components/canvas/SmoothenSlider.vue";
import CanvasButton from "@/components/canvas/CanvasButton.vue";
</script>

<template>
  <div class="rounded py-2 d-flex flex-column align-items-center">
    <!-- pas de titre texte : il elargirait tout le menu d'options. L'appui
         long sur l'icone explique a quoi sert le slider. -->
    <CanvasButton
      @click.prevent.stop
      size="sm"
      phosphor-icon="waves"
      :tooltipTitle="$t('canvas:tools.options.smoothen.tooltip.title')"
      :tooltipText="$t('canvas:tools.options.smoothen.tooltip.text')"
    />
    <div class="d-flex">
      <SmoothenSlider vertical />
    </div>
  </div>
</template>
